import React, { useCallback, useEffect, useMemo } from "react";
import "./index.scss";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterStartButtons,
  MdaePopupFooterEndButtons,
} from "../common_widgets/popup";
import MdaeAccordian from "../common_widgets/accordion";
import { Item } from "devextreme-react/accordion";
import MdaeButton from "../common_widgets/button";
import {
  formatManualCaseObjectBeforeSave,
  getInitialDatagridData,
  SET_ADD_CASE_MANUAL_DATA,
  SET_ADD_CASE_MANUAL_FLAGS,
  SET_ADD_MANUAL_CASE_REFERENCE_DATA,
  SET_CASE_BILLING_PROVIDERS,
  SET_CASE_PROVIDERS,
  SET_CASE_RENDERING_PROVIDERS,
  SET_MANUAL_CASE_FACILITY_LIST,
  TOGGLE_ADD_CASE_MANUAL_POPUP,
  initialAddCasweManualFormData,
  SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
  UPDATE_DATAGRID_DATA,
  DELETE_DATAGRID_ROW,
  SET_MANUAL_CASE_SAVE_BUTTON_DISABLED,
  SET_MANUAL_CASE_PARAMS,
  SET_IS_MANUAL_EXPEDITE_CASE_SEARCH,
} from "./reducer/add-case-manual-reducer";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap";
import { Validator } from "devextreme-react";
import {
  CustomRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
} from "devextreme-react/validator";
import MdaeSelectBox from "../common_widgets/select-box/component";
import { isEqual, last } from "lodash";
import { bindActionCreators } from "redux";
import { callOperation, actions as asyncActions } from "async-ops";
import { GET_FACILITY_LIST } from "./services/get-facility-list";
import { GET_CODER_LIST } from "./services/get-coder-list";
import { GET_CASE_PROVIDERS } from "./services/get-case-providers";
import { GET_ADMISSION_TYPE_LIST } from "./services/get-admission-type-list";
import { GET_DISCHARGE_DISPOSITION } from "./services/get-discharge-disposition";
import { GET_ADMISSION_SOURCE_LIST } from "./services/get-admission-source-list";
import { IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT } from "./services/is-coder-worklow-enabled-for-client";
import MdaeTextBox from "../common_widgets/text-box";
import MdaeLookup from "../common_widgets/lookup";
import MdaeDateBox from "../common_widgets/date-box";
import MdaeDataGrid, { IMdaeDataGridProps } from "../common_widgets/data-grid";
import MdaeScrollView from "../common_widgets/scroll-view";
import SearchProvider, { toggleSearchProviderPopup } from "./search-provider";
import {
  auditDateRangeConfirmationMessage,
  CASE_ADD_LOCATIONS,
  columnConfigs,
  editorConfigs,
} from "./constant";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../../common_components/mdae-common-reducer";
import $ from "jquery";
import { VALIDATE_ENTERED_CODE } from "./services/validate-entered-code";
import ShowValidationSummary, {
  ICodeValidationSummaryObject,
  toggleValidationSummaryPopup,
} from "./show-validation-summary-popup";
import { ADD_CASE_MANULLY } from "./services/add-case-manually";
import { UPDATE_CASE_MANULLY } from "./services/update-case-manually";
import { DELETE_CASE_CODE } from "./services/delete-case-code";
import { DELETE_CASE_LINE } from "./services/delete-case-line";
import { DELETE_CASE_PARTICIPANT } from "./services/delete-case-participant";
import { refreshCaseListFromDb } from "../../pages/external-audit/case-list/case-list-detail";
import MdaeNumericBox from "../common_widgets/numeric-box";
import { convertDate } from "../../utils/dateUtils";
import { SET_REFRESH_AUDIT_SUMMARY_DATA } from "../../pages/external-audit/reducers/external-audit-reducer";
import { showNotifyPopup } from "../common-functions";
import { SAVE_AUDIT } from "../../pages/external-audit/services/save-audit";
import { GET_TARGET_DATA_LOOKUPS } from "../../pages/external-audit/services/get-target-data-lookups";
import { GET_AUDIT_GROUPS } from "../../pages/external-audit/services/get-audit-groups";
import { GET_PROCESS_MANAGERS_LIST } from "../../pages/external-audit/services/get-process-managers-list";
import { redirectToAudit, toggleCaseDetailPopup } from "../../pages/external-audit/case-detail/case-detail-common-functions";
import { SET_AUDIT_PROPERTIES_DATA } from "../../pages/external-audit/reducers/audit-properties-reducer";
import { toggleCaseSearchCriteriaListPopupVisible } from "../case-search/case-search-list-popup";
import { SET_CASE_FORM_DATA } from "../../pages/external-audit/case-detail/case-data/reducers/case-data-reducer";
import { CASE_DETAIL_POPUP_MODES } from "../../pages/external-audit/case-detail/component";
import { GET_AUDIT_PERIOD } from "../../pages/external-audit/services/get-audit-period";
import { SET_MANUAL_EXPEDITE_CASE_SEARCH_COMPLETE_CASE_DETAIL } from "../../pages/external-audit/case-detail/reducers/case-detail-reducer";
import { format } from "date-fns";
import MdaeAutoComplete from "../common_widgets/autocomplete";
import { GET_PAYER_FINANCIAL_CLASS_LIST } from "./services/get-payer-financial-class-list";
import { GET_PAYER_TYPE_LIST } from "../../pages/analyzer/denials-predictor/services/get-payer-type-list";

const COLOUR={PINK:"PINK",GREEN:"GREEN"};
const ipDiagnosisGridMaxRowCount = 25;
const opDiagnosisGridMaxRowCount = 25;
const proDiagnosisGridMaxRowCount = 12;
const ipDiagnosisGridDefaultIncreaseRowCount = 1;
const opDiagnosisGridDefaultIncreaseRowCount = 1;
const proDiagnosisGridDefaultIncreaseRowCount = 1;
const iExternalCauseOfInjuryGridMaxRowCount = 12;
const iExternalCauseOfInjuryGridDefaultIncreaseRowCount = 1;
const ipICDProcedureGridMaxRowCount = 25;
const ipICDProcedureGridDefaultIncreaseRowCount = 1;
const opVisitReasonGridMaxRowCount = 3;
const opVisitReasonGridDefaultIncreaseRowCount = 1;
const proPayerGridMaxRowCount = 11;
const proPayerGridDefaultIncreaseRowCount = 1;
const iPayerGridMaxRowCount = 11;
const iPayerGridDefaultIncreaseRowCount = 1;
const iConditionCodeGridMaxRowCount = 24;
const iConditionCodeGridDefaultIncreaseRowCount = 1;
const ipLinesGridMaxRowCount = 999;
const opLinesGridMaxRowCount = 999;
const proLinesGridMaxRowCount = 50;
const ipLinesGridDefaultIncreaseRowCount = 1;
const opLinesGridDefaultIncreaseRowCount = 1;
const proLinesGridDefaultIncreaseRowCount = 1;
const iOccurenceCodesGridMaxRowCount = 24;
const iOccurenceCodesGridDefaultIncreaseRowCount = 1;
const iOccurenceSpanCodesGridMaxRowCount = 24;
const iOccurenceSpanCodesGridDefaultIncreaseRowCount = 1;
const auditCaseParticipantsKey = "auditCaseParticipants";
const diagnosesCaseCodesKey = "diagnosesCaseCodes";
const icdProcedureCodesKey = "icdProcedureCodes";
const externalInjuryCodesKey = "externalInjuryCodes";
const visitReasonCodesKey = "visitReasonCodes";
const auditCaseLinesKey = "auditCaseLines";
const conditionCodesKey = "conditionCodes";
const occurrenceCodesKey = "occurrenceCodes";
const occurrenceSpanCodesKey = "occurrenceSpanCodes";
interface IAddCaseManual {
  refreshCasesList: () => void;
  location?: string;
}
export const ADD_MANUAL_CASE_POPUP_MODES = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
};
export const ADD_MANUAL_CASE_POPUP_LOCATIONS = {
  EXTERNAL_AUDIT: "EXTERNAL_AUDIT",
  CASE_SAEARCH_PAGE: "CASE_SAEARCH_PAGE",
}
export const caseDetailValidationGroup = "caseDetailValidationGroup";
interface IAddCaseManualDataGridProps extends IMdaeDataGridProps {
  addNewRow: (
    dataSourceKey: string,
    maxCount: number,
    stepCount: number
  ) => void;
}
const AddCaseManual: React.FC<IAddCaseManual> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const auditPropertiesReducer = useSelector(
    (state) => state["auditPropertiesReducer"],
    isEqual
  );
  const firstEaRound = useSelector(
    (state) => last(state["externalAuditReducer"].eaAuditRounds),
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const auditGroups = useSelector(
    (state) => state["auditPropertiesReducer"].auditGroups,
    isEqual
  );
  const addCaseManualFormData = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualFormData,
    isEqual
  );
  const addCaseManualFlags = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualFlags,
    isEqual
  );
  const addCaseManualPopupMode = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualPopupMode,
    isEqual
  );
  const caseRenderingProviders = useSelector(
    (state) => state["addCaseManualReducer"].caseRenderingProviders,
    isEqual
  );
  const coderList = useSelector(
    (state) => state["addCaseManualReducer"].coderList,
    isEqual
  );
  const dischargeDispositionList = useSelector(
    (state) => state["addCaseManualReducer"].dischargeDispositionList,
    isEqual
  );
  const admissionSourceList = useSelector(
    (state) => state["addCaseManualReducer"].admissionSourceList,
    isEqual
  );
  const admissionTypeList = useSelector(
    (state) => state["addCaseManualReducer"].admissionTypeList,
    isEqual
  );
  const caseBillingProviders = useSelector(
    (state) => state["addCaseManualReducer"].caseBillingProviders,
    isEqual
  );
  const caseProviders = useSelector(
    (state) => state["addCaseManualReducer"].caseProviders,
    isEqual
  );
  const claimTypes = useSelector(
    (state) => state["addCaseManualReducer"].claimTypes,
    isEqual
  );
  const patientTypes = useSelector(
    (state) => state["addCaseManualReducer"].patientTypes,
    isEqual
  );
  const addCaseManualReducer = useSelector(
    (state) => state["addCaseManualReducer"],
    isEqual
  );
  const addCaseToRoundNumber = useSelector(
    (state) => state["externalAuditReducer"].addCaseToRoundNumber,
    isEqual
  );
  const roundStartDate = useSelector(
    (state) => state["externalAuditReducer"].roundStartDate,
    isEqual
  );
  const isManulCaseSaveButtonDisabled = useSelector(
    (state) => state["addCaseManualReducer"].isManulCaseSaveButtonDisabled,
    isEqual
  );
  const processesTemplatesList = useSelector(
    (state) => state["auditPropertiesReducer"].processesTemplatesList,
    isEqual
  );
  const caseSearchPageData = useSelector(
    (state) => state["caseSearchPageReducer"]
  );
  const processManagers = useSelector(
    (state) => state["auditPropertiesReducer"].processManagers,
    isEqual
  );
  const currentUserId = useSelector(
    (state) => state["auditPropertiesReducer"].currentUserId,
    isEqual
  );
    const currentUser = useSelector(
      (state) => state["mdaeNavigationBarReducer"].currentUser,
      isEqual
    );
    const caseDataTabData = useSelector(
      (state) => state["caseDataReducer"].caseData
    );
  const payerFinancialClassList = useSelector(
    (state) => state["addCaseManualReducer"].payerFinancialClassList
   );
  const payerTypeList = useSelector(
    (state: any) => state["denialsPredictorReducer"].payerTypeList
  );
const setManualExpediteCaseSearch = useCallback(
  (params, isNewAfterSave) => {
    dispatch({
      type: SET_IS_MANUAL_EXPEDITE_CASE_SEARCH,
      data: {
        isManualExpediteCaseSearch: true,
      },
    });
    dispatch({
      type: SET_MANUAL_CASE_PARAMS,
      data: {
        saveManualCaseDataParams: {
          refreshCasesList: props.refreshCasesList,
          params: params,
          isNewAfterSave: isNewAfterSave,
          location: props.location,
        },
      },
    });
    let addCaseManualFormDataToSave = formatManualCaseObjectBeforeSave(
      addCaseManualFormData,
      auditPropertiesData?.eaAuditId,
      firstEaRound?.eaRoundId,
      addCaseToRoundNumber,
      roundStartDate
    );
    validateCaseCodes(
      dispatch,
      addCaseManualFormData,
      addCaseManualFormDataToSave
    ).then((isValid) => {
      if (isValid) {
        onAddExpediteManualCasesToAuditBtnClick(
          dispatch,
          asyncActions,
          addCaseManualFormData,
          claimTypes,
          currentUser,
          props
        );
      } else return;
    });
  },
  [
    addCaseManualFormData,
    props.refreshCasesList,
    props.location,
    auditPropertiesData,
    firstEaRound,
    addCaseToRoundNumber,
    roundStartDate,
    currentUser,
    claimTypes,
  ]
);
 
  const showAuditDateRangeConfirmationPopup = (
    params,
    isNewAfterSave,
    message
  ) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          hideConfirmationPopup(dispatch);
           if (
             props.location ===
             ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE
           ) {
            setManualExpediteCaseSearch(params,isNewAfterSave);
           } else {
             validateAndSaveManualCase(params, isNewAfterSave);
           }
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        cancelShown: false,
        width: 450,
        height: 250,
        contentHtml: message,
        title: "Warning",
        confirmLabel: "Save",
        cancelLabel: "Cancel",
        onDecline: () => hideConfirmationPopup(dispatch),
      },
    });
  };
const checkAuditDateRangePopup = (params, isNewAfterSave) => {
  let result = null;
  if (params.validationGroup) result = params.validationGroup.validate();
  if (result && result.isValid) {
    let auditDateRangeConfirmationPopupVisible = false;
    let fromDateToBeChecked = null;
    let toDateToBeChecked = null;
    const fromDate = auditPropertiesData?.serviceFromDate ?? caseSearchPageData.serviceFrom;
    const toDate = auditPropertiesData?.serviceToDate ?? caseSearchPageData.serviceTo;
    if (
      addCaseManualFormData?.claimTypeCd == "I" &&
      addCaseManualFormData?.patientType == "IP"
    ) {
      fromDateToBeChecked = addCaseManualFormData?.admissionDateString;
      toDateToBeChecked = addCaseManualFormData?.dischargeDateString;
    } else{
      fromDateToBeChecked = addCaseManualFormData?.statementFromDateString;
      toDateToBeChecked = addCaseManualFormData?.statementToDateString;
    }
    if (
      !(
        new Date(fromDateToBeChecked) >= new Date(fromDate) &&
        new Date(fromDateToBeChecked) <= new Date(toDate) &&
        new Date(toDateToBeChecked) >= new Date(fromDate) &&
        new Date(toDateToBeChecked) <= new Date(toDate)
      )
    ) {
      auditDateRangeConfirmationPopupVisible = true;
    }
    if (auditDateRangeConfirmationPopupVisible) {
      showAuditDateRangeConfirmationPopup(
        params,
        isNewAfterSave,
        auditDateRangeConfirmationMessage
      );
      return false;
    } else return true;
  } else {
    const brokenRules = result?.brokenRules;
    if (brokenRules?.length > 0) {
      const validationSummaryObject = {
        codeLookupValidationMessageButtonTitle: "OK",
        showCodeValidationSummary: true,
        lookUpValidationMessage: [],
      };
      toggleValidationSummaryPopup(
        dispatch,
        true,
        validationSummaryObject,
        "Required Fields"
      );
      return false;
    }
  }
};

  const validateAndSaveManualCase = (params, isNewAfterSave = false) => {
    saveManualCase (
   dispatch,
   addCaseManualPopupMode,
   addCaseManualFormData,
   auditPropertiesData,
   firstEaRound,
   addCaseToRoundNumber,
   roundStartDate,
   props.refreshCasesList,
   params,
   isNewAfterSave,
   caseDataTabData
 )
  };

  const bgColour = useCallback((e, colour) => {
    if (colour === COLOUR.PINK) {
      e.cellElement.style.backgroundColor = "rgba(244, 67, 54, .32)";
    } else if (colour === COLOUR.GREEN) {
      e.cellElement.style.backgroundColor = "rgba(139, 195, 74, .32)";
    }
  }, []);

  const payerCellPrepared = useCallback(
    (e) => {
      if (e.rowType === "data") {
        if (e.column.dataField === "claimFilingIndCd") {
          if (
            e.data.claimFilingIndCd &&
            e.data.claimFilingIndCd.length > 0 &&
            e.data.claimFilingIndCd.length <= 5
          ) {
            bgColour(e, COLOUR.GREEN);
          }
        }

        if (e.column.dataField === "participantName") {
          var name = e.data.participantName;
          var type = e.data.claimFilingIndCd;

          if ((!name || name.trim() === "") && type && type.trim() !== "") {
            bgColour(e, COLOUR.PINK);
          }
          else if (
            (!type || type.trim() === "") &&
            e.cellElement.classList.contains("dx-editor-cell") &&
            (!name || name.trim() === "")
          ) {
            bgColour(e, COLOUR.PINK);
            const input = e.cellElement.querySelector(
              ".dx-texteditor-input-container"
            );
            if (input && "style" in input) {
              (input as HTMLElement).style.backgroundColor =
                "rgba(244, 67, 54, .32)";
            }
          } else if (name && name.length > 0 && name.length <= 60) {
            bgColour(e, COLOUR.GREEN);
          }
        }
      }
    },
    [bgColour]
  );

  const payerDataGridConfigs = useMemo(
    () =>
      getPayerDataGridConfigs(
        addCaseManualFlags,
        auditCaseParticipantsKey,
        payerFinancialClassList,
        payerTypeList,
        dispatch,
        payerCellPrepared
      ),
    [payerFinancialClassList, payerTypeList, payerCellPrepared]
  );
  const diagnosisDataGridConfigs = useMemo(
    () =>
      getDiagnosisDataGridConfigs(
        addCaseManualFlags,
        diagnosesCaseCodesKey,
        dispatch
      ),
    [addCaseManualFlags]
  );
  const lineDataGridConfigs = useMemo(
    () =>
      getLineDataGridConfigs(
        addCaseManualFlags,
        auditCaseLinesKey,
        {
          lineCoders: coderList,
          diagnosisDataSource:
            addCaseManualFormData.diagnosesCaseCodes?.filter(
              (x) => x?.codeValue
            ) || [],
        },
        dispatch
      ),
    [addCaseManualFlags, coderList, addCaseManualFormData?.diagnosesCaseCodes]
  );
  const icdProcedureDataGridConfigs = useMemo(
    () =>
      getIcdProcedureDataGridConfigs(
        addCaseManualFlags,
        icdProcedureCodesKey,
        dispatch
      ),
    []
  );
  const externalCauseOfInjuryDataGridConfigs = useMemo(
    () =>
      getExternalCauseOfInjuryDataGridConfigs(
        addCaseManualFlags,
        externalInjuryCodesKey,
        dispatch
      ),
    []
  );
  const visitReasonCodeDataGridConfigs = useMemo(
    () =>
      getVisitReasonCodeDataGridConfigs(
        addCaseManualFlags,
        visitReasonCodesKey,
        dispatch
      ),
    []
  );
  const conditionCodesDataGridConfigs = useMemo(
    () =>
      getConditionCodesDataGridConfigs(
        addCaseManualFlags,
        conditionCodesKey,
        dispatch
      ),
    []
  );
  const occurenceCodesDataGridConfigs = useMemo(
    () =>
      getOccurenceCodesDataGridConfigs(
        addCaseManualFlags,
        occurrenceCodesKey,
        dispatch
      ),
    []
  );
  const occurenceSpanCodeDataGridConfigs = useMemo(
    () =>
      getOccurenceSpanCodeDataGridConfigs(
        addCaseManualFlags,
        occurrenceSpanCodesKey,
        dispatch
      ),
    []
  );
  useEffect(() => {
    if (props.location === ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE) {
      if (processesTemplatesList?.length == 0 || !processesTemplatesList) {
        asyncAction.asyncOperationStart(GET_TARGET_DATA_LOOKUPS, {
          eaAuditId: auditPropertiesData?.eaAuditId,
        });
      }
      if (auditGroups?.length == 0 || !auditGroups) {
        asyncAction.asyncOperationStart(GET_AUDIT_GROUPS, {
          eaAuditId: auditPropertiesData?.eaAuditId,
        });
      }
      if (processManagers?.length == 0 || !processManagers){
        asyncAction.asyncOperationStart(
          GET_PROCESS_MANAGERS_LIST,
          "External Audit Creation"
        )
      }
    }
  }, []);
  //for removing diagnosis map items which are not currently present in diagnosis table
  useEffect(() => {
    //when diagnosis code array updates, find and remove items from lines diagnose map which are
    //not present in diagnosis code array
    const linesDataSource: any[] = addCaseManualFormData?.auditCaseLines.slice();
    if (linesDataSource.length > 0) {
      linesDataSource.forEach((lineItem) => {
        (lineItem.diagnosesMap?.slice() as any[])?.forEach(
          (diagnoseItem, index) => {
            if (
              (addCaseManualFormData?.diagnosesCaseCodes as any[])?.findIndex(
                (code) => code.codeValue === diagnoseItem
              ) === -1
            ) {
              lineItem.diagnosesMap.splice(index, 1);
            }
          }
        );
      });
      dispatch({
        type: SET_ADD_CASE_MANUAL_DATA,
        data: {
          addCaseManualFormData: { [auditCaseLinesKey]: linesDataSource },
        },
      });
    }
  }, [addCaseManualFormData?.diagnosesCaseCodes]);
  //for generating initial empty rows
  useEffect(() => {
    if (addCaseManualPopupMode === ADD_MANUAL_CASE_POPUP_MODES.CREATE)
      setTimeout(() => {
        dispatch({
          type: SET_ADD_CASE_MANUAL_DATA,
          data: {
            addCaseManualFormData: {
              ...getInitialDatagridData(addCaseManualFormData),
            },
          },
        });
      }, 1000);
  }, [addCaseManualFormData?.claimTypeCd, addCaseManualFormData?.patientType]);

  //for reference datasources
  useEffect(() => {
    dispatch({ type: SHOW_LOADER });
    callOperation(GET_FACILITY_LIST, auditPropertiesData?.auditGroupId).then(
      (facilityResponse: any[]) => {
        dispatch({ type: HIDE_LOADER });
        dispatch({
          type: SET_MANUAL_CASE_FACILITY_LIST,
          data: {
            manualCaseFacilityList:facilityResponse
          },
        });
        /*Removed filtering of excludedFacilityIdList from facilityList
          For bug 87205 not needed as in CopymanualCaseFacilityList we bringing all the facilities removing all excluded facilities */   
      }
    );
  }, [auditPropertiesData?.auditGroupId]);
  useEffect(() => {
    dispatch({ type: SHOW_LOADER });
    callOperation(GET_CASE_PROVIDERS).then((caseProviders: any[]) => {
      dispatch({
        type: SET_CASE_BILLING_PROVIDERS,
        data: {
          caseProviders,
        },
      });
      dispatch({
        type: SET_CASE_PROVIDERS,
        data: {
          caseBillingProviders: caseProviders,
        },
      });
      dispatch({
        type: SET_CASE_RENDERING_PROVIDERS,
        data: {
          caseRenderingProviders: caseProviders,
        },
      });
    });
    asyncAction.asyncOperationStart(IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT);
    asyncAction.asyncOperationStart(GET_ADMISSION_TYPE_LIST);
    asyncAction.asyncOperationStart(GET_ADMISSION_SOURCE_LIST);
    asyncAction.asyncOperationStart(GET_DISCHARGE_DISPOSITION);
    asyncAction.asyncOperationStart(GET_PAYER_FINANCIAL_CLASS_LIST);
    asyncAction.asyncOperationStart(GET_PAYER_TYPE_LIST);
  }, []);
  useEffect(() => {
    if (addCaseManualFlags.isCoderWorkFlowEnabled) {
      asyncAction.asyncOperationStart(GET_CODER_LIST);
    }
  }, [addCaseManualFlags.isCoderWorkFlowEnabled]);
  useEffect(() => {
    if (auditPropertiesReducer?.originalClaimTypes?.length > 0) {
      const index = auditPropertiesReducer?.originalClaimTypes.findIndex(
        (x) => x.description.toUpperCase() === "ALL"
      );
      const claimTypes = auditPropertiesReducer?.originalClaimTypes.slice(0);
      if (claimTypes.length > 0) {
        const index = claimTypes.findIndex((claim) => claim.description === "All" || claim.code === "A");
        if (index !== -1) {
          claimTypes.splice(index, 1);
        }
      }
      dispatch({
        type: SET_ADD_MANUAL_CASE_REFERENCE_DATA,
        data: {
          claimTypes,
          patientTypes: auditPropertiesReducer?.patientTypes,
        },
      });
    }
  }, [auditPropertiesReducer?.originalClaimTypes]);

  const getAddCaseManualPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleAddCaseManualPopup(dispatch, false);
        }}
      >{addCaseManualReducer.addCaseManualPopupTitle}</MdaePopupTitle>
    );
  };
  const setProcessManagerToCurrentUser = () => {
      dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: {
            processManagerId: currentUserId,
          },
        },
      });
  };
  return (
    <div>
      <ShowValidationSummary refreshCasesList={props.refreshCasesList} />
      <MdaePopup
        minHeight={"80%"}
        width={1300}
        wrapperAttr={{ class: "add-case-manual-popup" }}
        mdaeTitleRender={getAddCaseManualPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_ADD_CASE_MANUAL_POPUP,
            reducerName: "addCaseManualReducer",
            widgetOptionBindings: {
              visible: "isAddCaseManualPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => (
          <MdaePopupContent>
            <div className="add-case-manual-popup-content">
              <div
                className="col-xs-12 padding-none align-items-center"
                style={{ marginBottom: 20 }}
              >
                <div className="col-xs-8 remove-padding flex-item">
                  <div style={{ marginRight: 20 }}>
                    <MdaeSelectBox
                      id={"ddlClaimType"}
                      tabIndex={1}
                      required
                      width={300}
                      disabled={
                        addCaseManualPopupMode ===
                        ADD_MANUAL_CASE_POPUP_MODES.UPDATE
                      }
                      placeholder="Choose Claim Type"
                      mdaeDropDownBoxTitle={"Claim Type"}
                      displayExpr={"description"}
                      valueExpr={"code"}
                      dataSource={claimTypes}
                      onValueChanged={(e) => {
                        dispatch({
                          type: SET_ADD_CASE_MANUAL_FLAGS,
                          data: {
                            isSelectedClaimTypeHospital:
                              e.value?.toUpperCase() === "I",
                          },
                        });
                      }}
                      mdaeDataUpdaterConfig={[
                        {
                          actionType: SET_ADD_CASE_MANUAL_DATA,
                          reducerName: "addCaseManualReducer",
                          widgetOptionBindings: {
                            value: "addCaseManualFormData.claimTypeCd",
                          },
                        },
                        {
                          actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                          reducerName: "addCaseManualReducer",
                          widgetOptionBindings: {
                            isValid: "isManualAddCaseFormDataValid",
                          },
                        },
                      ]}
                    >
                      <Validator validationGroup={caseDetailValidationGroup}>
                        <RequiredRule message="Claim Type is Required" />
                      </Validator>
                    </MdaeSelectBox>
                  </div>
                  <div>
                    <MdaeSelectBox
                      id={"ddlPatientType"}
                      tabIndex={2}
                      required
                      width={300}
                      visible={addCaseManualFlags.isSelectedClaimTypeHospital}
                      disabled={
                        addCaseManualPopupMode ===
                        ADD_MANUAL_CASE_POPUP_MODES.UPDATE
                      }
                      dataSource={patientTypes}
                      placeholder="Choose Patient Type"
                      mdaeDropDownBoxTitle={"Patient Type"}
                      displayExpr={"description"}
                      valueExpr={"code"}
                      onValueChanged={(e) => {
                        dispatch({
                          type: SET_ADD_CASE_MANUAL_FLAGS,
                          data: {
                            isSelectedPatientTypeInPatient:
                              e.value?.toUpperCase() === "IP",
                          },
                        });
                      }}
                      mdaeDataUpdaterConfig={[
                        {
                          actionType: SET_ADD_CASE_MANUAL_DATA,
                          reducerName: "addCaseManualReducer",
                          widgetOptionBindings: {
                            value: "addCaseManualFormData.patientType",
                          },
                        },
                      ]}
                    >
                      <Validator validationGroup={caseDetailValidationGroup}>
                        <CustomRule
                          message="Patient Type is required"
                          reevaluate
                          validationCallback={(params) => {
                            if (
                              addCaseManualFlags.isSelectedClaimTypeHospital
                            ) {
                              if (params.value) return true;
                              return false;
                            } else return true;
                          }}
                        />
                      </Validator>
                    </MdaeSelectBox>
                  </div>
                </div>
                <div className="col-xs-4 text-right remove-margin">
                  <MdaeButton
                    id="btnCaseDetailReport"
                    style={{ marginBottom: 5 }}
                    role="secondary"
                    onClick={() => {
                      window.open(
                        "/lookup/index",
                        "Code Search",
                        "height=600,width=1220,scrollbars=1"
                      );
                    }}
                  >
                    Code Search
                  </MdaeButton>
                </div>
              </div>
              {/* ACCORDION */}
              <div className="col-xs-12 padding-none">
                <MdaeScrollView scrollByContent>
                  <MdaeAccordian
                    collapsible
                    multiple
                    animationDuration={300}
                    deferRendering={false}
                    onItemRendered={(e) => {
                      if (
                        addCaseManualPopupMode ===
                        ADD_MANUAL_CASE_POPUP_MODES.UPDATE
                      ) {
                        e.component.expandItem(0);
                        e.component.expandItem(1);
                        e.component.expandItem(2);
                        e.component.expandItem(3);
                      }
                    }}
                  >
                    <Item title="Case Header">
                      <div className="row">
                        <div className="col-xs-4">
                          <div className="col-xs-12 padding-none content-item">
                            <MdaeSelectBox
                              id={"ddlManualFacility"}
                              tabIndex={3}
                              required
                              placeholder="Choose Facility"
                              showClearButton
                              readOnly={addCaseManualFlags.isFacilityAudit}
                              mdaeDropDownBoxTitle={"Facility"}
                              displayExpr={"facilityName"}
                              valueExpr={"facilityName"}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value: "addCaseManualFormData.facilityName",
                                  },
                                },
                                {
                                  actionType: SET_MANUAL_CASE_FACILITY_LIST,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    dataSource: "manualCaseFacilityList",
                                  },
                                },
                                {
                                  actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    isValid: "isManualAddCaseFormDataValid",
                                  },
                                },
                              ]}
                            >
                              <Validator
                                validationGroup={caseDetailValidationGroup}
                              >
                                <RequiredRule message="Facility is required" />
                              </Validator>
                            </MdaeSelectBox>
                          </div>
                          <div className="col-xs-12 padding-none content-item">
                            <div className="col-xs-6 padding-none">
                              <MdaeTextBox
                                id={"txtPatientFirstName"}
                                tabIndex={4}
                                required
                                mdaeTextBoxTitle={"Patient First Name"}
                                maxLength={100}
                                style={{ marginRight: 10 }}
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_CASE_MANUAL_DATA,
                                    reducerName: "addCaseManualReducer",
                                    widgetOptionBindings: {
                                      value:
                                        "addCaseManualFormData.patientFirstName",
                                    },
                                  },
                                  {
                                    actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                                    reducerName: "addCaseManualReducer",
                                    widgetOptionBindings: {
                                      isValid: "isManualAddCaseFormDataValid",
                                    },
                                  },
                                ]}
                              >
                                <Validator
                                  validationGroup={caseDetailValidationGroup}
                                >
                                  <RequiredRule message="Patient First Name is required" />
                                  <StringLengthRule
                                    message="Patient First Name should be less than 100 characters"
                                    min={0}
                                    max={100}
                                  />
                                </Validator>
                              </MdaeTextBox>
                            </div>
                            <div className="col-xs-6 padding-none">
                              <MdaeTextBox
                                id={"txtPatientLastName"}
                                tabIndex={5}
                                required
                                mdaeTextBoxTitle={"Patient Last Name"}
                                maxLength={100}
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_CASE_MANUAL_DATA,
                                    reducerName: "addCaseManualReducer",
                                    widgetOptionBindings: {
                                      value:
                                        "addCaseManualFormData.patientLastName",
                                    },
                                  },
                                  {
                                    actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                                    reducerName: "addCaseManualReducer",
                                    widgetOptionBindings: {
                                      isValid: "isManualAddCaseFormDataValid",
                                    },
                                  },
                                ]}
                              >
                                <Validator
                                  validationGroup={caseDetailValidationGroup}
                                >
                                  <RequiredRule message="Patient Last Name is required" />
                                  <StringLengthRule
                                    message="Patient Last Name should be less than 100 characters"
                                    min={0}
                                    max={100}
                                  />
                                </Validator>
                              </MdaeTextBox>
                            </div>
                          </div>
                          <div className="col-xs-12 padding-none content-item">
                            <MdaeTextBox
                              id={"txtPatientMRN"}
                              tabIndex={6}
                              required
                              mdaeTextBoxTitle={"MRN"}
                              maxLength={30}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value: "addCaseManualFormData.patientMRN",
                                  },
                                },
                                {
                                  actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    isValid: "isManualAddCaseFormDataValid",
                                  },
                                },
                              ]}
                            >
                              <Validator
                                validationGroup={caseDetailValidationGroup}
                              >
                                <RequiredRule message="Patient MRN is required" />
                                <StringLengthRule
                                  message="Patient MRN should be less than 30 characters"
                                  min={0}
                                  max={30}
                                />
                              </Validator>
                            </MdaeTextBox>
                          </div>
                          <div className="col-xs-12 padding-none content-item">
                            <MdaeTextBox
                              id={"txtPatientAcctNo"}
                              tabIndex={7}
                              required
                              mdaeTextBoxTitle={"Account Number"}
                              maxLength={30}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value:
                                      "addCaseManualFormData.patientAcctNo",
                                  },
                                },
                                {
                                  actionType: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    isValid: "isManualAddCaseFormDataValid",
                                  },
                                },
                              ]}
                            >
                              <Validator
                                validationGroup={caseDetailValidationGroup}
                              >
                                <RequiredRule message="Account Number is required" />
                                <StringLengthRule
                                  message="Account Number should be less than 30 characters"
                                  min={0}
                                  max={30}
                                />
                              </Validator>
                            </MdaeTextBox>
                          </div>
                          {/* //for hospital */}
                          {addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <>
                              <div className="col-xs-12 padding-none content-item align-items-center">
                                <div className="col-xs-11 padding-none">
                                  <MdaeLookup
                                    id="ddlLookupManualBillingProvider"
                                    mdaeLookupTitle="Billing Provider"
                                    tabIndex={8}
                                    displayExpr="providerFullName"
                                    valueExpr="clientProviderId"
                                    showClearButton
                                    dataSource={caseBillingProviders}
                                    mdaeDataUpdaterConfig={[
                                      {
                                        actionType: SET_ADD_CASE_MANUAL_DATA,
                                        reducerName: "addCaseManualReducer",
                                        widgetOptionBindings: {
                                          value:
                                            "addCaseManualFormData.billingProviderId",
                                        },
                                      },
                                    ]}
                                  />
                                </div>
                                <div className="col-xs-1">
                                  <MdaeButton
                                    stylingMode="text"
                                    role="dxButton"
                                    id="btnManualSearchBillingProvider"
                                    icon="fa fa-edit application-section-primary-color"
                                    onClick={() => {
                                      toggleSearchProviderPopup(
                                        dispatch,
                                        true,
                                        "BillingProvider"
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-xs-12 padding-none content-item align-items-center">
                                <div className="col-xs-11 padding-none">
                                  <MdaeLookup
                                    id="ddlLookupManualRenderingProvider"
                                    mdaeLookupTitle="Rendering Provider"
                                    required
                                    tabIndex={9}
                                    displayExpr="providerFullName"
                                    readOnly={
                                      addCaseManualFlags.isProviderAudit
                                    }
                                    dataSource={caseRenderingProviders}
                                    valueExpr="clientProviderId"
                                    showClearButton
                                    mdaeDataUpdaterConfig={[
                                      {
                                        actionType: SET_ADD_CASE_MANUAL_DATA,
                                        reducerName: "addCaseManualReducer",
                                        widgetOptionBindings: {
                                          value:
                                            "addCaseManualFormData.renderingProviderId",
                                        },
                                      },
                                    ]}
                                  >
                                    <Validator
                                      validationGroup={
                                        caseDetailValidationGroup
                                      }
                                    >
                                      <CustomRule
                                        message="Rendering Provider is required"
                                        reevaluate
                                        validationCallback={(params) => {
                                          if (
                                            addCaseManualFormData?.claimTypeCd?.toUpperCase() ===
                                            "P"
                                          ) {
                                            if (params.value) return true;
                                            return false;
                                          } else return true;
                                        }}
                                      />
                                    </Validator>
                                  </MdaeLookup>
                                </div>
                                {/* for isProviderAudit*/}
                                {addCaseManualFlags.isProviderAudit || (
                                  <div className="col-xs-1">
                                    <MdaeButton
                                      stylingMode="text"
                                      role="dxButton"
                                      tabIndex={10}
                                      id="btnManualSearchRenderingProvider"
                                      icon="fa fa-edit application-section-primary-color"
                                      onClick={() => {
                                        toggleSearchProviderPopup(
                                          dispatch,
                                          true,
                                          "RenderingProvider"
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {/*  for non hospital*/}
                          {!addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <div className="col-xs-12 padding-none content-item content-item align-items-center">
                              <div className="col-xs-12 padding-none">
                                <div className="col-xs-11 padding-none">
                                  <MdaeLookup
                                    id="ddlLookupManualAttendingProvider"
                                    tabIndex={11}
                                    mdaeLookupTitle="Attending Provider"
                                    displayExpr="providerFullName"
                                    valueExpr="clientProviderId"
                                    required={true}
                                    readOnly={
                                      addCaseManualFlags.isProviderAudit
                                    }
                                    showClearButton
                                    dataSource={caseProviders}
                                    mdaeDataUpdaterConfig={[
                                      {
                                        actionType: SET_ADD_CASE_MANUAL_DATA,
                                        reducerName: "addCaseManualReducer",
                                        widgetOptionBindings: {
                                          value:
                                            "addCaseManualFormData.attendingProviderId",
                                        },
                                      },
                                    ]}
                                  >
                                    <Validator
                                      validationGroup={
                                        caseDetailValidationGroup
                                      }
                                    >
                                      <CustomRule
                                        message="Attending Provider is required"
                                        reevaluate
                                        validationCallback={(params) => {
                                          if (
                                            addCaseManualFormData?.claimTypeCd?.toUpperCase() ===
                                            "I"
                                          ) {
                                            if (params.value) return true;
                                            return false;
                                          } else return true;
                                        }}
                                      />
                                    </Validator>
                                  </MdaeLookup>
                                </div>
                                {/*  isProviderAudit */}
                                {addCaseManualFlags.isProviderAudit || (
                                  <div className="col-xs-1">
                                    <MdaeButton
                                      stylingMode="text"
                                      role="dxButton"
                                      id="btnManualSearchAttendingProvider"
                                      tabIndex={12}
                                      elementAttr={{
                                        title: "Search Attending Provider",
                                      }}
                                      icon="fa fa-edit application-section-primary-color"
                                      onClick={() => {
                                        toggleSearchProviderPopup(
                                          dispatch,
                                          true,
                                          "AttendingProvider"
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {/*  isCoderWorkFlowEnabled  */}
                          {!addCaseManualFlags.isCoderWorkFlowEnabled || (
                            <div className="col-xs-12 remove-padding">
                              <MdaeLookup
                                id="ddlLookupManualCoder"
                                tabIndex={13}
                                readOnly={addCaseManualFlags.isCoderAudit}
                                mdaeLookupTitle="Coder"
                                displayExpr="refCoderDescription"
                                valueExpr="refCoderId"
                                dataSource={coderList}
                                showClearButton
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_CASE_MANUAL_DATA,
                                    reducerName: "addCaseManualReducer",
                                    widgetOptionBindings: {
                                      value: "addCaseManualFormData.refCoderId",
                                    },
                                  },
                                ]}
                              />
                            </div>
                          )}
                        </div>
                        <div className="col-xs-3">
                          {/* !$parent.$parent.ac.isSelectedClaimTypeHospital || !$parent.$parent.ac.isSelectedPatientTypeInPatient) */}
                          {!addCaseManualFlags.isSelectedClaimTypeHospital ||
                            !addCaseManualFlags.isSelectedPatientTypeInPatient || (
                              <>
                                <div className="col-xs-12 padding-none content-item">
                                  <div className="col-xs-9 padding-none">
                                    <MdaeDateBox
                                      id="txtManualAddmissionDate"
                                      tabIndex={14}
                                      mdaeDateBoxTitle="Admit Date / Hr"
                                      required
                                      onValueChanged={(e) => {
                                        //todo
                                      }}
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.admissionDateString",
                                          },
                                        },
                                      ]}
                                    >
                                      <Validator
                                        validationGroup={
                                          caseDetailValidationGroup
                                        }
                                      >
                                        <CustomRule
                                          message="Admission Date is Required"
                                          reevaluate
                                          validationCallback={(params) => {
                                            if (
                                              addCaseManualFormData?.claimTypeCd ===
                                                "I" &&
                                              addCaseManualFormData?.patientType ===
                                                "IP" &&
                                              addCaseManualFormData?.admissionDateString ==
                                                undefined
                                            ) {
                                              return false;
                                            } else {
                                              return true;
                                            }
                                          }}
                                        />
                                      </Validator>
                                    </MdaeDateBox>
                                  </div>
                                  <div
                                    className="col-xs-3"
                                    style={{ paddingRight: 0 }}
                                  >
                                    <MdaeTextBox
                                      id={"txtManualAddmissionHour"}
                                      tabIndex={15}
                                      mdaeTextBoxTitle={""}
                                      maxLength={2}
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.admitHourValue",
                                          },
                                        },
                                      ]}
                                    >
                                      <Validator
                                        validationGroup={
                                          caseDetailValidationGroup
                                        }
                                      >
                                        <RangeRule
                                          message="Admit hour should be a number from 0 to 23"
                                          min={0}
                                          max={23}
                                        />
                                      </Validator>
                                    </MdaeTextBox>
                                  </div>
                                </div>
                                <div className="col-xs-12 padding-none content-item">
                                  <div className="col-xs-9 padding-none">
                                    <MdaeDateBox
                                      id="txtManualDischargeDate"
                                      tabIndex={16}
                                      mdaeDateBoxTitle="Discharge Date / Hr"
                                      required
                                      onValueChanged={(e) => {
                                        //todo
                                      }}
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.dischargeDateString",
                                          },
                                        },
                                      ]}
                                    >
                                      <Validator
                                        validationGroup={
                                          caseDetailValidationGroup
                                        }
                                      >
                                        <CustomRule
                                          message="Discharge Date is Required"
                                          reevaluate
                                          validationCallback={(params) => {
                                            if (
                                              addCaseManualFormData?.claimTypeCd ===
                                                "I" &&
                                              addCaseManualFormData?.patientType ===
                                                "IP" &&
                                              addCaseManualFormData?.dischargeDateString ==
                                                undefined
                                            ) {
                                              return false;
                                            } else {
                                              return true;
                                            }
                                          }}
                                        />
                                      </Validator>
                                    </MdaeDateBox>
                                  </div>
                                  <div
                                    className="col-xs-3"
                                    style={{ paddingRight: 0 }}
                                  >
                                    <MdaeTextBox
                                      id={"txtManualDischargeHour"}
                                      tabIndex={17}
                                      mdaeTextBoxTitle={""}
                                      maxLength={2}
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.dischargeHourValue",
                                          },
                                        },
                                      ]}
                                    >
                                      <Validator
                                        validationGroup={
                                          caseDetailValidationGroup
                                        }
                                      >
                                        <RangeRule
                                          message="Discharge hour should be a number from 00 to 23"
                                          min={0}
                                          max={23}
                                        />
                                      </Validator>
                                    </MdaeTextBox>
                                  </div>
                                </div>
                              </>
                            )}
                          {/*  ($parent.$parent.ac.isSelectedClaimTypeHospital && $parent.$parent.ac.isSelectedPatientTypeInPatient) */}
                          {(addCaseManualFlags.isSelectedClaimTypeHospital &&
                            addCaseManualFlags.isSelectedPatientTypeInPatient) || (
                            <>
                              <div className="col-xs-12 padding-none content-item">
                                <MdaeDateBox
                                  id="dtServiceStart"
                                  mdaeDateBoxTitle="Statement From Date"
                                  required
                                  tabIndex={18}
                                  onValueChanged={(e) => {
                                    if (e.event && e.value) {
                                      const updatedAuditCaseLinesDataSource = addCaseManualFormData?.auditCaseLines.slice(
                                        0
                                      );
                                      updatedAuditCaseLinesDataSource.forEach(
                                        (element) => {
                                          if (!element?.fromServiceDateString)
                                            element.fromServiceDateString = convertDate(
                                              e.value
                                            );
                                        }
                                      );
                                      dispatch({
                                        type: SET_ADD_CASE_MANUAL_DATA,
                                        data: {
                                          addCaseManualFormData: {
                                            [auditCaseLinesKey]: updatedAuditCaseLinesDataSource,
                                          },
                                        },
                                      });
                                    }
                                  }}
                                  mdaeDataUpdaterConfig={[
                                    {
                                      actionType: SET_ADD_CASE_MANUAL_DATA,
                                      reducerName: "addCaseManualReducer",
                                      widgetOptionBindings: {
                                        value:
                                          "addCaseManualFormData.statementFromDateString",
                                      },
                                    },
                                  ]}
                                >
                                  <Validator
                                    validationGroup={caseDetailValidationGroup}
                                  >
                                    <CustomRule
                                      message="Statement From Date is required"
                                      reevaluate
                                      validationCallback={(params) => {
                                        if (
                                          addCaseManualFormData?.claimTypeCd ==
                                            "P" &&
                                          addCaseManualFormData?.statementFromDateString ==
                                            undefined
                                        ) {
                                          return false;
                                        } else if (
                                          addCaseManualFormData?.claimTypeCd ==
                                            "I" &&
                                          addCaseManualFormData?.patientType ==
                                            "OP" &&
                                          addCaseManualFormData?.statementFromDateString ==
                                            undefined
                                        ) {
                                        } else {
                                          // self.fillServiceDateDefault();  todo for auditcaselines
                                          return true;
                                        }
                                      }}
                                    />
                                  </Validator>
                                </MdaeDateBox>
                              </div>
                              <div className="col-xs-12 padding-none content-item">
                                <MdaeDateBox
                                  id="dtServiceEnd"
                                  tabIndex={19}
                                  mdaeDateBoxTitle="Statement To Date"
                                  required
                                  onValueChanged={(e) => {
                                    //todo
                                  }}
                                  mdaeDataUpdaterConfig={[
                                    {
                                      actionType: SET_ADD_CASE_MANUAL_DATA,
                                      reducerName: "addCaseManualReducer",
                                      widgetOptionBindings: {
                                        value:
                                          "addCaseManualFormData.statementToDateString",
                                      },
                                    },
                                  ]}
                                >
                                  <Validator
                                    validationGroup={caseDetailValidationGroup}
                                  >
                                    <CustomRule
                                      message="Statement To Date is required"
                                      reevaluate
                                      validationCallback={() => {
                                        if (
                                          addCaseManualFormData?.claimTypeCd ==
                                            "P" &&
                                          addCaseManualFormData?.statementToDateString ==
                                            undefined
                                        ) {
                                          return false;
                                        } else if (
                                          addCaseManualFormData?.claimTypeCd ==
                                            "I" &&
                                          addCaseManualFormData?.patientType ==
                                            "OP" &&
                                          addCaseManualFormData?.statementToDateString ==
                                            undefined
                                        ) {
                                        } else {
                                          // self.fillServiceDateDefault();  todo for auditcaselines
                                          return true;
                                        }
                                      }}
                                    />
                                  </Validator>
                                </MdaeDateBox>
                              </div>
                            </>
                          )}
                          {/*  !$parent.$parent.ac.isSelectedClaimTypeHospital || !$parent.$parent.ac.isSelectedPatientTypeInPatient*/}
                          {!addCaseManualFlags.isSelectedClaimTypeHospital ||
                            !addCaseManualFlags.isSelectedPatientTypeInPatient || (
                              <div className="col-xs-12 padding-none content-item">
                                <MdaeSelectBox
                                  id={"ddlManualAdmissionType"}
                                  tabIndex={20}
                                  placeholder="Choose Admit Type"
                                  showClearButton
                                  mdaeDropDownBoxTitle={"Admit Type"}
                                  displayExpr={"codeDesc"}
                                  valueExpr={"codeValue"}
                                  dataSource={admissionTypeList}
                                  mdaeDataUpdaterConfig={[
                                    {
                                      actionType: SET_ADD_CASE_MANUAL_DATA,
                                      reducerName: "addCaseManualReducer",
                                      widgetOptionBindings: {
                                        value:
                                          "addCaseManualFormData.admissionTypeCode",
                                      },
                                    },
                                  ]}
                                />
                              </div>
                            )}
                          {/*  (!$parent.$parent.ac.isSelectedClaimTypeHospital */}
                          {!addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <>
                              <div className="col-xs-12 padding-none content-item">
                                <MdaeSelectBox
                                  id={"ddlManualAdmissionSource"}
                                  tabIndex={21}
                                  placeholder="Choose Admit Source"
                                  showClearButton
                                  mdaeDropDownBoxTitle={"Admit Source"}
                                  displayExpr={"codeDesc"}
                                  valueExpr={"codeValue"}
                                  dataSource={admissionSourceList}
                                  onOpened={() => {
                                    //todo
                                  }}
                                  mdaeDataUpdaterConfig={[
                                    {
                                      actionType: SET_ADD_CASE_MANUAL_DATA,
                                      reducerName: "addCaseManualReducer",
                                      widgetOptionBindings: {
                                        value:
                                          "addCaseManualFormData.admissionSourceCode",
                                      },
                                    },
                                  ]}
                                />
                              </div>
                              <div className="col-xs-12 padding-none content-item">
                                <MdaeSelectBox
                                  id={"ddlManualDischargeStatus"}
                                  tabIndex={22}
                                  placeholder="Choose Discharge Status"
                                  showClearButton
                                  mdaeDropDownBoxTitle={"Discharge Status"}
                                  displayExpr={"codeDesc"}
                                  valueExpr={"codeValue"}
                                  dataSource={dischargeDispositionList}
                                  onOpened={() => {
                                    //todo
                                  }}
                                  mdaeDataUpdaterConfig={[
                                    {
                                      actionType: SET_ADD_CASE_MANUAL_DATA,
                                      reducerName: "addCaseManualReducer",
                                      widgetOptionBindings: {
                                        value:
                                          "addCaseManualFormData.dischargeStatus",
                                      },
                                    },
                                  ]}
                                />
                              </div>
                            </>
                          )}
                          <div className="col-xs-12 padding-none content-item">
                            <MdaeNumericBox
                              id="txtManualOriginalPaymentAmount"
                              tabIndex={23}
                              mdaeNumberBoxTitle="Original Payment Amount"
                              className="bottom-margin text-right"
                              format="$ #,##0.##"
                              showSpinButtons={false}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value:
                                      "addCaseManualFormData.originalPaymentAmt",
                                  },
                                },
                              ]}
                            />
                          </div>
                        </div>
                        <div className="col-xs-5">
                          <div className="row">
                            <label
                              className="col-xs-12 manually-add-case-grid-title"
                              style={{ marginLeft: 0 }}
                            >
                              Payers/Payer Type
                            </label>
                          </div>
                          <div className="row hide-manual-case-add-header">
                            <div className="col-xs-12 text-right">
                              <div>
                                <MdaeDataGrid {...payerDataGridConfigs} />
                              </div>
                              <div>
                                <MdaeButton
                                  id="btnManualAddNewPayer"
                                  tabIndex={24}
                                  role="dxButton"
                                  text="Add Row"
                                  stylingMode="text"
                                  style={{ marginTop: 10 }}
                                  className="application-section-primary-color text-button"
                                  icon="fa fa-plus application-section-primary-color"
                                  onClick={payerDataGridConfigs.addNewRow}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Item>
                    <Item
                      title={
                        addCaseManualFlags.isSelectedClaimTypeHospital
                          ? addCaseManualFlags.isSelectedPatientTypeInPatient
                            ? "Diagnoses / ICD Procedures / External Cause of Injury"
                            : "Diagnosis"
                          : "Diagnosis"
                      }
                    >
                      <div className="col-xs-12">
                        <div className="row">
                          <div
                            className={
                              addCaseManualFlags.isSelectedPatientTypeInPatient
                                ? "col-xs-3"
                                : "col-xs-4"
                            }
                          >
                            <div className="row">
                              <label className="col-xs-12 padding-none manually-add-case-grid-title">
                                Diagnoses
                              </label>
                            </div>
                            <div className="row hide-manual-case-add-header">
                              <div className="col-xs-12">
                                <MdaeDataGrid {...diagnosisDataGridConfigs} />
                              </div>
                              <div
                                className="text-right"
                                style={{ marginTop: 10 }}
                              >
                                <MdaeButton
                                  id="btnManualAddNewDiagnoses"
                                  tabIndex={25}
                                  role="dxButton"
                                  text="Add Row"
                                  stylingMode="text"
                                  style={{ marginTop: 10 }}
                                  className="application-section-primary-color text-button"
                                  icon="fa fa-plus application-section-primary-color"
                                  onClick={diagnosisDataGridConfigs.addNewRow}
                                />
                              </div>
                            </div>
                          </div>
                          {(!addCaseManualFlags.isSelectedPatientTypeInPatient &&
                            addCaseManualFlags.isSelectedClaimTypeHospital) ||
                            !addCaseManualFlags.isSelectedClaimTypeHospital || (
                              <div className="col-xs-3">
                                <div className="row">
                                  <label className="col-xs-12 padding-none manually-add-case-grid-title">
                                    ICD Procedures
                                  </label>
                                  <div className="row hide-manual-case-add-header">
                                    <div className="col-xs-12">
                                      <MdaeDataGrid
                                        {...icdProcedureDataGridConfigs}
                                      />
                                    </div>
                                    <div
                                      className="text-right"
                                      style={{ marginTop: 10 }}
                                    >
                                      <MdaeButton
                                        id="btnManualAddNewIcdProcedure"
                                        role="dxButton"
                                        tabIndex={26}
                                        text="Add Row"
                                        stylingMode="text"
                                        style={{ marginTop: 10 }}
                                        className="application-section-primary-color text-button"
                                        icon="fa fa-plus application-section-primary-color"
                                        onClick={
                                          icdProcedureDataGridConfigs.addNewRow
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          {!addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <div
                              className={
                                addCaseManualFlags.isSelectedPatientTypeInPatient
                                  ? "col-xs-3"
                                  : "col-xs-4"
                              }
                            >
                              <div className="row">
                                <label
                                  className="col-xs-12 padding-none manually-add-case-grid-title"
                                  style={{ marginLeft: 14 }}
                                >
                                  External Cause of Injury
                                </label>
                              </div>
                              <div className="row hide-manual-case-add-header">
                                <div className="col-xs-12 text-right">
                                  <div>
                                    <MdaeDataGrid
                                      {...externalCauseOfInjuryDataGridConfigs}
                                    />
                                  </div>
                                  <div>
                                    <MdaeButton
                                      id="btnManualAddNewExternalCauseOfInjury"
                                      role="dxButton"
                                      text="Add Row"
                                      tabIndex={27}
                                      stylingMode="text"
                                      style={{ marginTop: 10 }}
                                      className="application-section-primary-color text-button"
                                      icon="fa fa-plus application-section-primary-color"
                                      onClick={
                                        externalCauseOfInjuryDataGridConfigs.addNewRow
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {(!addCaseManualFlags.isSelectedPatientTypeInPatient &&
                            addCaseManualFlags.isSelectedClaimTypeHospital) ||
                            !addCaseManualFlags.isSelectedClaimTypeHospital || (
                              <div className="col-xs-3">
                                <div className="row content-item">
                                  <div className="col-xs-6 padding-none">
                                    <MdaeTextBox
                                      id="txtAdmitDx"
                                      tabIndex={28}
                                      mdaeTextBoxTitle="Admit Diagnoses"
                                      style={{ marginRight: 10 }}
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.admitDx",
                                          },
                                        },
                                      ]}
                                    />
                                  </div>
                                  <div className="col-xs-6 padding-none">
                                    <MdaeTextBox
                                      id="txtDrgDiagCode"
                                      tabIndex={29}
                                      mdaeTextBoxTitle="DRG"
                                      mdaeDataUpdaterConfig={[
                                        {
                                          actionType: SET_ADD_CASE_MANUAL_DATA,
                                          reducerName: "addCaseManualReducer",
                                          widgetOptionBindings: {
                                            value:
                                              "addCaseManualFormData.drgDiagCode",
                                          },
                                        },
                                      ]}
                                    >
                                      <Validator
                                        validationGroup={
                                          caseDetailValidationGroup
                                        }
                                      >
                                        <StringLengthRule
                                          message="DRG Code should be less than 30 characters"
                                          min={0}
                                          max={30}
                                        />
                                      </Validator>
                                    </MdaeTextBox>
                                  </div>
                                </div>
                              </div>
                            )}

                          {(addCaseManualFlags.isSelectedPatientTypeInPatient &&
                            addCaseManualFlags.isSelectedClaimTypeHospital) ||
                            !addCaseManualFlags.isSelectedClaimTypeHospital || (
                              <div
                                className={
                                  addCaseManualFlags.isSelectedPatientTypeInPatient
                                    ? "col-xs-3"
                                    : "col-xs-4"
                                }
                              >
                                <div className="row">
                                  <label
                                    className="col-xs-12 padding-none manually-add-case-grid-title"
                                    style={{ marginLeft: 12 }}
                                  >
                                    Visit Reasons
                                  </label>
                                </div>
                                <div className="row hide-manual-case-add-header">
                                  <div className="col-xs-12 text-right">
                                    <div>
                                      <MdaeDataGrid
                                        {...visitReasonCodeDataGridConfigs}
                                      />
                                    </div>
                                    <div>
                                      <MdaeButton
                                        id="btnManualAddNewVisitReason"
                                        role="dxButton"
                                        text="Add Row"
                                        tabIndex={30}
                                        stylingMode="text"
                                        style={{ marginTop: 10 }}
                                        className="application-section-primary-color text-button"
                                        icon="fa fa-plus application-section-primary-color"
                                        onClick={
                                          visitReasonCodeDataGridConfigs.addNewRow
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </Item>
                    <Item title="Line Items">
                      <div>
                        <div className="row hide-manual-case-add-header">
                          <div className="col-xs-12">
                            <MdaeDataGrid {...lineDataGridConfigs} />
                            <div className="text-right">
                              <MdaeButton
                                id="btnManualAddNewLines"
                                role="dxButton"
                                text="Add Row"
                                tabIndex={31}
                                stylingMode="text"
                                style={{ marginTop: 10 }}
                                className="application-section-primary-color text-button"
                                icon="fa fa-plus application-section-primary-color"
                                onClick={lineDataGridConfigs.addNewRow}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{ marginTop: 10, marginRight: 0 }}
                        >
                          <div className="col-xs-3 pull-right text-right">
                            <MdaeButton
                              id="btnShowHideLineAllFieldsView"
                              role="secondary"
                              stylingMode="text"
                              tabIndex={32}
                              className="application-section-primary-color"
                              onClick={() => {
                                dispatch({
                                  type: SET_ADD_CASE_MANUAL_FLAGS,
                                  data: {
                                    isLinesAllFieldsShown: !addCaseManualFlags.isLinesAllFieldsShown,
                                  },
                                });
                              }}
                            >
                              {(addCaseManualFlags.isLinesAllFieldsShown
                                ? "Hide "
                                : "Show ") + " all fields view"}
                            </MdaeButton>
                          </div>
                        </div>
                      </div>
                    </Item>
                    <Item title="Codes / Extra Fields">
                      <div>
                        <div
                          className="row remove-margin"
                          style={{ padding: 10, paddingLeft: 0 }}
                        >
                          <div className="col-xs-3 padding-none">
                            <MdaeTextBox
                              id="txtClinicalTrialIdentifier"
                              tabIndex={33}
                              mdaeTextBoxTitle="Clinical Trial Number"
                              style={{ marginRight: 20 }}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value:
                                      "addCaseManualFormData.clinicalTrialIdentifier",
                                  },
                                },
                              ]}
                            >
                              <Validator
                                validationGroup={caseDetailValidationGroup}
                              >
                                <StringLengthRule
                                  message="Clinical Trial Identifier should be less than 50 characters"
                                  min={0}
                                  max={50}
                                />
                              </Validator>
                            </MdaeTextBox>
                          </div>
                          <div className="col-xs-3 padding-none">
                            <MdaeTextBox
                              id="txtInvestDeviceExmptNo"
                              tabIndex={34}
                              mdaeTextBoxTitle="Investigational Device Exemption"
                              style={{ marginRight: 20 }}
                              mdaeDataUpdaterConfig={[
                                {
                                  actionType: SET_ADD_CASE_MANUAL_DATA,
                                  reducerName: "addCaseManualReducer",
                                  widgetOptionBindings: {
                                    value:
                                      "addCaseManualFormData.investDeviceExmptNo",
                                  },
                                },
                              ]}
                            >
                              <Validator
                                validationGroup={caseDetailValidationGroup}
                              >
                                <StringLengthRule
                                  message="Investigational Device Exemption should be less than 50 characters"
                                  min={0}
                                  max={50}
                                />
                              </Validator>
                            </MdaeTextBox>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className={
                              addCaseManualFlags.isSelectedClaimTypeHospital
                                ? "col-xs-4"
                                : "col-xs-6"
                            }
                          >
                            <div className="row">
                              <label className="col-xs-12 padding-none manually-add-case-grid-title">
                                Condition Codes
                              </label>
                            </div>
                            <div className="row hide-manual-case-add-header">
                              <div className="col-xs-12">
                                <div>
                                  <MdaeDataGrid
                                    {...conditionCodesDataGridConfigs}
                                  />
                                </div>
                                <div>
                                  <MdaeButton
                                    id="btnManualAddNewCondition"
                                    role="dxButton"
                                    text="Add Row"
                                    tabIndex={35}
                                    stylingMode="text"
                                    style={{ marginTop: 10 }}
                                    className="application-section-primary-color text-button"
                                    icon="fa fa-plus application-section-primary-color"
                                    onClick={
                                      conditionCodesDataGridConfigs.addNewRow
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {!addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <div className="col-xs-4">
                              <div className="row">
                                <label
                                  className="col-xs-12 padding-none manually-add-case-grid-title"
                                  style={{ marginLeft: 14 }}
                                >
                                  Occurrence Codes
                                </label>
                              </div>
                              <div className="row hide-manual-case-add-header">
                                <div className="col-xs-12">
                                  <div>
                                    <MdaeDataGrid
                                      {...occurenceCodesDataGridConfigs}
                                    />
                                  </div>
                                  <div>
                                    <MdaeButton
                                      id="btnManualAddNewCondition"
                                      role="dxButton"
                                      text="Add Row"
                                      tabIndex={36}
                                      stylingMode="text"
                                      style={{ marginTop: 10 }}
                                      className="application-section-primary-color text-button"
                                      icon="fa fa-plus application-section-primary-color"
                                      onClick={
                                        occurenceCodesDataGridConfigs.addNewRow
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {!addCaseManualFlags.isSelectedClaimTypeHospital || (
                            <div className="col-xs-4">
                              <div className="row">
                                <label
                                  className="col-xs-12 padding-none manually-add-case-grid-title"
                                  style={{ marginLeft: 14 }}
                                >
                                  Occurrence Span Codes
                                </label>
                              </div>
                              <div className="row hide-manual-case-add-header">
                                <div className="col-xs-12">
                                  <div>
                                    <MdaeDataGrid
                                      {...occurenceSpanCodeDataGridConfigs}
                                    />
                                  </div>
                                  <div>
                                    <MdaeButton
                                      id="btnManualAddNewOccuranceSpan"
                                      role="dxButton"
                                      text="Add Row"
                                      tabIndex={37}
                                      stylingMode="text"
                                      style={{ marginTop: 10 }}
                                      className="application-section-primary-color text-button"
                                      icon="fa fa-plus application-section-primary-color"
                                      onClick={
                                        occurenceSpanCodeDataGridConfigs.addNewRow
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Item>
                  </MdaeAccordian>
                </MdaeScrollView>
              </div>
            </div>
          </MdaePopupContent>
        )}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelAddCaseManualPopup"}
                  tabIndex={38}
                  role={"secondary"}
                  onClick={() => {
                    toggleAddCaseManualPopup(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"btnSaveAddCaseManualPopup"}
                  tabIndex={39}
                  role={"primary"}
                  validationGroup={caseDetailValidationGroup}
                  disabled={isManulCaseSaveButtonDisabled}
                  onClick={(e) => {
                    setManualCaseSaveButtonDisabledProperty(dispatch, true);
                    if (checkAuditDateRangePopup(e, false))
                      if (
                        props.location ===
                        ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE
                      ) {
                        setManualExpediteCaseSearch(e,false);
                      } else {
                        validateAndSaveManualCase(e);
                      }
                  }}
                >
                  {props.location ===
                  ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE
                    ? "Save"
                    : "Save And Close"}
                </MdaeButton>
                <MdaeButton
                  id={"btnSaveAndCloseAddCaseManualPopup"}
                  tabIndex={40}
                  role={"primary"}
                  validationGroup={caseDetailValidationGroup}
                  disabled={isManulCaseSaveButtonDisabled}
                  visible={
                    props.location !==
                    ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE
                  }
                  onClick={(e) => {
                    setManualCaseSaveButtonDisabledProperty(dispatch, true);
                    if (checkAuditDateRangePopup(e, true))
                      validateAndSaveManualCase(e, true);
                  }}
                >
                  Save and Create New
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      />
      <SearchProvider />
    </div>
  );
};

const getPayerDataGridConfigs = (addCaseManualFlags, datGridKey, payerFinancialClassList, payerTypeList, dispatch, payerCellPrepared) => {
const payerTypeDataSource = Array.isArray(payerTypeList)
  ? payerTypeList.map((item) => item.code ?? "")
  : [];
   
  const payerDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdPayerGridContainer",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    searchPanel: {
      visible: false,
    },
    editing: {
      mode: "cell",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
      confirmDelete: false,
    },
    mdaeColumns: [
      {
        dataField: "participantName",
        caption: "Name",
        dataType: "string",
        validationRules: [
          {
            type: "stringLength",
            min: 0,
            max: 60,
            message: "Participant Name should be less than 60 characters",
          },
        ],
        editCellRender: (e) => (
          <MdaeAutoComplete
            id={`txtAutocompleteParticipantName${e.rowIndex}`}
            dataSource={payerFinancialClassList || []}
            defaultValue={e.value}
            onValueChanged={(ex) => {
              e.setValue(ex.value);
            }}
          />
        ),
      },
      {
        dataField: "claimFilingIndCd",
        caption: "Payer Type",
        dataType: "string",
        width: 80,
        validationRules: [
          {
            type: "stringLength",
            min: 0,
            max: 5,
            message: "Claim Filing Code should be less than 5 characters",
          },
        ],
        editCellRender: (e) => (
          <MdaeAutoComplete
            id={`txtAutocompletePayerType${e.rowIndex}`}
            dataSource={payerTypeDataSource || []}
            defaultValue={e.value}
            onValueChanged={(ex) => {
              e.setValue(ex.value);
            }}
          />
        ),
      },
    ],
   
    repaintChangesOnly: true,
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_PARTICIPANT,
        e,
        datGridKey,
        e?.key?.eaCaseParticipantsId
      );
    },
    onRowInserted: (e) => {
      e.component.saveEditData();
    },
    noDataText: "",
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: payerCellPrepared,
    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",

    addNewRow: () => {
      if (!addCaseManualFlags.isSelectedClaimTypeHospital) {
        addNewRow(
          dispatch,
          datGridKey,
          proPayerGridMaxRowCount,
          proPayerGridDefaultIncreaseRowCount
        );
      } else if (addCaseManualFlags.isSelectedClaimTypeHospital) {
        if (addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            iPayerGridMaxRowCount,
            iPayerGridDefaultIncreaseRowCount
          );
        } else if (!addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            iPayerGridMaxRowCount,
            iPayerGridDefaultIncreaseRowCount
          );
        }
      }
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return payerDataGridConfigs;
};
const getDiagnosisColumns = (flags, referenceData = null) => {
  if (flags?.isSelectedClaimTypeHospital) {
    if (flags?.isSelectedPatientTypeInPatient) {
      return columnConfigs(referenceData).hospital.inpatient.diagnoses;
    } else {
      return columnConfigs(referenceData).hospital.outPatient.diagnoses;
    }
  } else {
    return columnConfigs(referenceData).professional.diagnoses;
  }
};

const getDiagnosisDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const diagnosisDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdDiagnosis",
    paging: {
      enabled: false,
      pageSize: 12,
    },
    mdaeColumns: getDiagnosisColumns(addCaseManualFlags),
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    sorting: {
      mode: "none",
    },
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      if (!addCaseManualFlags.isSelectedClaimTypeHospital) {
        addNewRow(
          dispatch,
          datGridKey,
          proDiagnosisGridMaxRowCount,
          proDiagnosisGridDefaultIncreaseRowCount
        );
      } else if (addCaseManualFlags.isSelectedClaimTypeHospital) {
        if (addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            ipDiagnosisGridMaxRowCount,
            ipDiagnosisGridDefaultIncreaseRowCount
          );
        } else if (!addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            opDiagnosisGridMaxRowCount,
            opDiagnosisGridDefaultIncreaseRowCount
          );
        }
      }
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return diagnosisDataGridConfigs;
};

const getIcdProcedureDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const icdProcedureDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdIcdProcedure",
    paging: {
      enabled: false,
      pageSize: 12,
    },
    sorting: {
      mode: "none",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    columns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "ICD Procedure Code is required" },
        ],
      },
    ],
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      if (addCaseManualFlags.isSelectedPatientTypeInPatient) {
        addNewRow(
          dispatch,
          datGridKey,
          ipICDProcedureGridMaxRowCount,
          ipICDProcedureGridDefaultIncreaseRowCount
        );
      }
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return icdProcedureDataGridConfigs;
};

const getExternalCauseOfInjuryDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const externalCauseOfInjuryDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdExternalCauseOfInjury",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    columns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "Injury code is required" },
        ],
      },
    ],
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      addNewRow(
        dispatch,
        datGridKey,
        iExternalCauseOfInjuryGridMaxRowCount,
        iExternalCauseOfInjuryGridDefaultIncreaseRowCount
      );
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return externalCauseOfInjuryDataGridConfigs;
};

const getVisitReasonCodeDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const visitReasonCodeDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdVisitReasonCode",
    paging: {
      enabled: true,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    columns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "Visit Reason code is required" },
        ],
      },
    ],
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      addNewRow(
        dispatch,
        datGridKey,
        opVisitReasonGridMaxRowCount,
        opVisitReasonGridDefaultIncreaseRowCount
      );
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return visitReasonCodeDataGridConfigs;
};
const getLineColumns = (flags, referenceData) => {
  let linesColumnConfig = [];
  if (flags?.isSelectedClaimTypeHospital) {
    if (flags?.isSelectedPatientTypeInPatient) {
      if (flags?.isCoderWorkFlowEnabled)
        linesColumnConfig = columnConfigs(referenceData).hospital.inpatient
          .coderWorkflow.enabled.lineItemColumns;
      else
        linesColumnConfig = columnConfigs(referenceData).hospital.inpatient
          .coderWorkflow.disabled.lineItemColumns;
    } else {
      if (flags?.isCoderWorkFlowEnabled)
        linesColumnConfig = columnConfigs(referenceData).hospital.outPatient
          .coderWorkflow.enabled.lineItemColumns;
      else
        linesColumnConfig = columnConfigs(referenceData).hospital.outPatient
          .coderWorkflow.disabled.lineItemColumns;
    }
  } else {
    if (flags?.isCoderWorkFlowEnabled)
      linesColumnConfig = columnConfigs(referenceData).professional
        .coderWorkflow.enabled.lineItemColumns;
    else
      linesColumnConfig = columnConfigs(referenceData).professional
        .coderWorkflow.disabled.lineItemColumns;
  }
  if (flags.isLinesAllFieldsShown)
    linesColumnConfig = [
      ...linesColumnConfig,
      ...columnConfigs(referenceData).linesExtraFields,
    ];
  return linesColumnConfig;
};

const getLineDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  linesReferenceData,
  dispatch
) => {
  const lineDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdLine",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    mdaeColumns: getLineColumns(addCaseManualFlags, linesReferenceData),
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_LINE,
        e,
        datGridKey,
        e?.key?.eaCaseLineId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onEditingStart: () => {
      //todo
    },

    onOptionChanged: (e) => {
      if (e?.fullName === "editing.changes" && e?.value?.length > 0) {
        if (Object.keys(e.value[0]?.data || {}).includes("diagnosesMap")) {
          setTimeout(() => {
            e.component.saveEditData();
          });
        } else e.component.saveEditData();
      }
    },
    keyExpr: "unique",
    addNewRow: () => {
      //todo
      if (!addCaseManualFlags.isSelectedClaimTypeHospital) {
        addNewRow(
          dispatch,
          datGridKey,
          proLinesGridMaxRowCount,
          proLinesGridDefaultIncreaseRowCount,
          true
        );
      } else if (addCaseManualFlags.isSelectedClaimTypeHospital) {
        if (addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            ipLinesGridMaxRowCount,
            ipLinesGridDefaultIncreaseRowCount,
            true
          );
        } else if (!addCaseManualFlags.isSelectedPatientTypeInPatient) {
          addNewRow(
            dispatch,
            datGridKey,
            opLinesGridMaxRowCount,
            opLinesGridDefaultIncreaseRowCount,
            true
          );
        }
      }
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return lineDataGridConfigs;
};

const getConditionCodesDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const conditionCodesDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdConditionCodes",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    columns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "Condition code is required" },
        ],
      },
    ],
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    sorting: {
      mode: "none",
    },
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      addNewRow(
        dispatch,
        datGridKey,
        iConditionCodeGridMaxRowCount,
        iConditionCodeGridDefaultIncreaseRowCount
      );
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return conditionCodesDataGridConfigs;
};

const getOccurenceCodesDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const occurenceCodesDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdOccurenceCodes",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    columns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "Occurrence code is required" },
        ],
      },
      {
        dataField: "codeFromDate",
        caption: "Date 1",
        dataType: "date",
      },
    ],
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },

    onOptionChanged: (e) => commonChangeEvent(e),
    keyExpr: "unique",
    addNewRow: () => {
      addNewRow(
        dispatch,
        datGridKey,
        iOccurenceCodesGridMaxRowCount,
        iOccurenceCodesGridDefaultIncreaseRowCount
      );
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return occurenceCodesDataGridConfigs;
};

const getOccurenceSpanCodeDataGridConfigs = (
  addCaseManualFlags,
  datGridKey,
  dispatch
) => {
  const occurenceSpanCodeDataGridConfigs: IAddCaseManualDataGridProps = {
    id: "grdOccurenceSpanCode",
    paging: {
      enabled: false,
      pageSize: 3,
    },
    sorting: {
      mode: "none",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowDeleting: true,
      allowAdding: true,
    },
    mdaeColumns: [
      {
        dataField: "codeValue",
        editorOptions: editorConfigs.codeValue,
        caption: "Code",
        validationRules: [
          { type: "required", message: "Occurrence code is required" },
        ],
      },
      {
        dataField: "codeFromDate",
        caption: "Date 1",
        dataType: "date",
      },
      {
        dataField: "codeToDate",
        caption: "Date 2",
        dataType: "date",
      },
    ],
    noDataText: "",
    onRowRemoved: (e) => {
      deleteRow(
        dispatch,
        DELETE_CASE_CODE,
        e,
        datGridKey,
        e?.key?.eaCaseCodesId
      );
    },
    onRowUpdated: (e) => updateDataSouce(dispatch, datGridKey, e),
    onCellPrepared: () => {
      //todo
    },
    keyExpr: "unique",

    onOptionChanged: (e) => commonChangeEvent(e),
    addNewRow: () => {
      addNewRow(
        dispatch,
        datGridKey,
        iOccurenceSpanCodesGridMaxRowCount,
        iOccurenceSpanCodesGridDefaultIncreaseRowCount
      );
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_ADD_CASE_MANUAL_DATA,
        reducerName: "addCaseManualReducer",
        widgetOptionBindings: {
          dataSource: "addCaseManualFormData." + datGridKey,
        },
      },
    ],
  };
  return occurenceSpanCodeDataGridConfigs;
};
export default AddCaseManual;

//required common functions
const addNewRow = (
  dispatch,
  dataSourceKey,
  maxCount,
  stepCount,
  isForLinesDataGrid = false
) => {
  dispatch({
    type: SET_ADD_CASE_MANUAL_DATA,
    data: {
      isForAddRow: true,
      isForLinesDataGrid,
      dataSourceKey,
      maxCount,
      stepCount,
    },
  });
};
const deleteRow = (
  dispatch,
  deleteServiceKey,
  e,
  dataSourceKey,
  deleteRowId
) => {
  if (deleteRowId) callOperation(deleteServiceKey, deleteRowId);
  dispatch({
    type: DELETE_DATAGRID_ROW,
    data: { unique: e.key.unique, dataSourceKey },
  });
};
const updateDataSouce = (dispatch, dataSourceKey, e) => {
  dispatch({
    type: UPDATE_DATAGRID_DATA,
    data: { data: { ...e.data, isDirty: true }, dataSourceKey },
  });
};
export const setAddCaseManualPopupData = (dispatch, data) => {
  dispatch({
    type: SET_ADD_CASE_MANUAL_DATA,
    data: {
      addCaseManualFormData: { ...data },
    },
  });
  dispatch({
    type: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
    data: {
      isManualAddCaseFormDataValid: true,
    },
  });
};
export const toggleAddCaseManualPopup = (
  dispatch,
  isVisible,
  data = null,
  title = "Add Case",
  mode = ADD_MANUAL_CASE_POPUP_MODES.CREATE
) => {
  dispatch({
    type: TOGGLE_ADD_CASE_MANUAL_POPUP,
    data: {
      isAddCaseManualPopupVisible: isVisible,
      addCaseManualPopupTitle: title,
      addCaseManualPopupMode: mode,
    },
  });
  setTimeout(() => {
    dispatch({
      type: TOGGLE_ADD_CASE_MANUAL_POPUP,
      data: {
        addCaseManualPopupTitle: title,
      },
    });
  });
  if (data) {
    dispatch({
      type: SET_ADD_CASE_MANUAL_DATA,
      data: {
        addCaseManualFormData: { ...data },
      },
    });
  }
  dispatch({
    type: SET_ADD_MANUAL_CASE_FORM_DATA_VALID,
    data: {
      isManualAddCaseFormDataValid: true,
    },
  });
  setManualCaseSaveButtonDisabledProperty(dispatch, false);
};
export const insertManualCase = (
  dispatch,
  addCaseManualFormDataToSave,
  isNewAfterSave,
  refreshCasesList,
  auditPropertiesData,
  addCaseManualFormData,
  caseDataTabData
) =>{
  let auditSavePromise = Promise.resolve({ auditId: null });
  if (auditPropertiesData?.eaAuditId == null || auditPropertiesData?.eaAuditId === 0) {
    const auditDataToSave = {
      ...auditPropertiesData,
      serviceFromDate: addCaseManualFormData.statementFromDateString,
      serviceToDate: addCaseManualFormData.statementToDateString,
      claimType: addCaseManualFormData.claimTypeCd,
      eaRequesterId: caseDataTabData.requesterId,
      claimTypeCd: addCaseManualFormData.claimTypeCd,
      title: `${addCaseManualFormData.patientLastName}, ${addCaseManualFormData.patientFirstName}`,
      caseList: [],
    };
    auditSavePromise = callOperation(SAVE_AUDIT, auditDataToSave);
    addCaseManualFormDataToSave={...addCaseManualFormDataToSave,
    rqstrRecordSubmissionMethod: caseDataTabData.rqstrRecordSubmissionMethod,
    rqstrRecordSubmissionValue: caseDataTabData.rqstrRecordSubmissionValue,
    caseAddedFrom: CASE_ADD_LOCATIONS.CASE_SEARCH_PAGE,
  };
  }
  let savedAuditId = null;
  auditSavePromise.then((response) => {
    if(response.auditId){
      savedAuditId = response.auditId;
      addCaseManualFormDataToSave = {
      ...addCaseManualFormDataToSave,
      eaAuditId: savedAuditId,
    };
    }
    
    callOperation(ADD_CASE_MANULLY, addCaseManualFormDataToSave).then(
      (response) => {     
        if(savedAuditId != null){
          redirectToAudit(savedAuditId, response.eaCaseId);
          toggleAddCaseManualPopup(dispatch, false);
          dispatch({ type: HIDE_LOADER })
          return;
        }
        if(response?.message){
          showNotifyPopup(dispatch, response?.message);  
          return;
        }
        if(typeof refreshCasesList === "function")
          refreshCasesList();
        else refreshCaseListFromDb(dispatch, addCaseManualFormDataToSave?.auditId, true);
        dispatch({
          type: SET_REFRESH_AUDIT_SUMMARY_DATA,
          data: true,
        });
        if (response.isSaved && isNewAfterSave)
          toggleAddCaseManualPopup(dispatch, true, initialAddCasweManualFormData);
        else if (response.isSaved) toggleAddCaseManualPopup(dispatch, false);
        dispatch({ type: HIDE_LOADER });
        setManualCaseSaveButtonDisabledProperty(dispatch,false);
      }
    ).catch(() =>{
        dispatch({ type: HIDE_LOADER });
        setManualCaseSaveButtonDisabledProperty(dispatch,false);
    });
  });
};
export const updateManualCase = (
  dispatch,
  addCaseManualFormDataToSave,
  isNewAfterSave,
  refreshCasesList,
) => {
  callOperation(UPDATE_CASE_MANULLY, addCaseManualFormDataToSave).then(
    (response) => {
      if(typeof refreshCasesList === "function")
        refreshCasesList();
      else refreshCaseListFromDb(dispatch, addCaseManualFormDataToSave?.auditId);
      dispatch({
        type: SET_REFRESH_AUDIT_SUMMARY_DATA,
        data: true,
      });
      if (response.isSaved && isNewAfterSave)
        toggleAddCaseManualPopup(dispatch, true, initialAddCasweManualFormData);
      else if (response.isSaved) toggleAddCaseManualPopup(dispatch, false);
      dispatch({ type: HIDE_LOADER });
    }
  );
};
const commonChangeEvent = (e) => {
  if (e?.fullName === "editing.changes" && e?.value?.length > 0) {
    e.component.saveEditData();
  }
};
const hideConfirmationPopup = (dispatch) => {
  dispatch({
    type: TOGGLE_CONFIRMATION_POPUP,
    data: {
      visible: false,
    },
  });
  setManualCaseSaveButtonDisabledProperty(dispatch, false);
};
const onDataGridInitialized = (e, setterFunction) => {
  setterFunction(e?.component);
};
const validateRequiredLineFields = (addCaseManualFormData) => {
  const validationObject: ICodeValidationSummaryObject = {
    codeLookupValidationMessageButtonTitle: "OK",
    showCodeValidationSummary: false,
    lookUpValidationMessage: [],
  };
  if (addCaseManualFormData.auditCaseLines != null) {
    if (addCaseManualFormData.claimTypeCd.toLowerCase() == "p") {
      var fields = $.grep(addCaseManualFormData.auditCaseLines, (e: any) => {
        return (
          e.isDirty == true &&
          (!e.cptHcpcsCode ||
            !e.fromServiceDateString ||
            !e.serviceUnits ||
            !e.placeOfService)
        );
      });
      if (fields.length > 0) {
        validationObject.lookUpValidationMessage = [
          {
            code:
              "CPT/HCPCS, From Service Date, Units and Place of Service are required fields for a Line.",
          },
        ];
        validationObject.codeLookupValidationMessageButtonTitle = "OK";
        validationObject.showCodeValidationSummary = true;
      }
    } else if (
      addCaseManualFormData.claimTypeCd.toLowerCase() == "i" &&
      addCaseManualFormData.patientType.toLowerCase() == "op"
    ) {
      var fields = $.grep(addCaseManualFormData.auditCaseLines, (e: any) => {
        return (
          e.isDirty == true &&
          (!e.cptHcpcsCode || !e.fromServiceDateString || !e.serviceUnits)
        );
      });

      if (fields.length > 0) {
        validationObject.lookUpValidationMessage = [
          {
            code:
              "CPT/HCPCS, Service Date and Units are required fields for a Line.",
          },
        ];
        validationObject.codeLookupValidationMessageButtonTitle = "OK";
        validationObject.showCodeValidationSummary = true;
      }
    }
  }
  return validationObject;
};
const validateCaseCodes = (
  dispatch,
  addCaseManualFormData,
  addCaseManualFormDataToSave
) => {
  return new Promise<boolean>((resolve, reject) => {
    const linesValdationObject = validateRequiredLineFields(
      addCaseManualFormData
    );
    if (linesValdationObject.showCodeValidationSummary) {
      toggleValidationSummaryPopup(dispatch, true, linesValdationObject);
      resolve(false);
      return;
    }
    callOperation(VALIDATE_ENTERED_CODE, addCaseManualFormDataToSave).then(
      (response) => {
        const validationSummaryObject = {
          codeLookupValidationMessageButtonTitle: "Save",
          showCodeValidationSummary: true,
          lookUpValidationMessage: response,
        };
        if (response?.length > 0) {
          toggleValidationSummaryPopup(dispatch, true, validationSummaryObject);
          resolve(false);
        } else {
          resolve(true);
        }
      }
    );
  });
};

export const setManualCaseSaveButtonDisabledProperty = (dispatch,isDisabled) => {
  dispatch({
    type: SET_MANUAL_CASE_SAVE_BUTTON_DISABLED,
    data: {
      isManulCaseSaveButtonDisabled: isDisabled,
    },
  });
}

 export const saveManualCase = (
   dispatch,
   addCaseManualPopupMode,
   addCaseManualFormData,
   auditPropertiesData,
   firstEaRound,
   addCaseToRoundNumber,
   roundStartDate,
   refreshCasesList,
   params,
   isNewAfterSave,
   caseDataTabData
 ) => {
   dispatch({ type: SHOW_LOADER });
   let result = null;
   if (params.validationGroup) result = params.validationGroup.validate();
   if (result && result.isValid) {
     if (addCaseManualPopupMode === ADD_MANUAL_CASE_POPUP_MODES.CREATE) {
       let addCaseManualFormDataToSave = formatManualCaseObjectBeforeSave(
         addCaseManualFormData,
         auditPropertiesData?.eaAuditId,
         firstEaRound?.eaRoundId,
         addCaseToRoundNumber,
         roundStartDate
       );
       validateCaseCodes(
         dispatch,
         addCaseManualFormData,
         addCaseManualFormDataToSave
       )
         .then((isValid) => {
           if (isValid) {
             insertManualCase(
               dispatch,
               addCaseManualFormDataToSave,
               isNewAfterSave,
               refreshCasesList,
               auditPropertiesData,
               addCaseManualFormData,
               caseDataTabData
             );
           } else dispatch({ type: HIDE_LOADER });
         })
         .catch(() => {
           setManualCaseSaveButtonDisabledProperty(dispatch, false);
         });
     } else {
       const addCaseManualFormDataToSave = formatManualCaseObjectBeforeSave(
         addCaseManualFormData,
         auditPropertiesData?.eaAuditId,
         firstEaRound?.eaRoundId,
         addCaseToRoundNumber,
         roundStartDate,
         true
       );
       validateCaseCodes(
         dispatch,
         addCaseManualFormData,
         addCaseManualFormDataToSave
       ).then((isValid) => {
         if (isValid)
           updateManualCase(
             dispatch,
             addCaseManualFormDataToSave,
             isNewAfterSave,
             refreshCasesList
           );
         else dispatch({ type: HIDE_LOADER });
       });
     }
   }
 };

   export const onAddExpediteManualCasesToAuditBtnClick = (
  dispatch,
  asyncActions,
  addCaseManualFormData,
  claimTypes,
  currentUser,
  props,
) =>  {
      if (
        props.location === ADD_MANUAL_CASE_POPUP_LOCATIONS.CASE_SAEARCH_PAGE
      ) {
        toggleCaseSearchCriteriaListPopupVisible(dispatch, false);
         dispatch(asyncActions.asyncOperationStart(GET_AUDIT_PERIOD, {}));
        setTimeout(() => {
          dispatch({
            type: SET_CASE_FORM_DATA,
            data: {
              caseData: {
                claimTypeCd: addCaseManualFormData.claimTypeCd,
                processManagerId: currentUser.userId,
              },
            },
          });
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data: {
              auditPropertiesData: {
                startDate: new Date(),
              },
            },
          });
        }, 2000);
        //reset case detail popup data
        toggleCaseDetailPopup(
          dispatch,
          true,
          "Add Case",
          {},
          0
        );
  
        //open case detail popup with data
        setTimeout(() => {
          toggleCaseDetailPopup(
            dispatch,
            true,
            "Add Case",
            {
              ...addCaseManualFormData,
              mode: CASE_DETAIL_POPUP_MODES.CREATE,
              claimType: claimTypes?.find((x) => x.code === addCaseManualFormData.claimTypeCd)
                ?.description,
            },
            0
          );
          dispatch({
            type: SET_MANUAL_EXPEDITE_CASE_SEARCH_COMPLETE_CASE_DETAIL,
            data: {
              completeCaseDetail: {
                patientLastName: addCaseManualFormData.patientLastName,
                patientFirstName: addCaseManualFormData.patientFirstName,
                patientMRN: addCaseManualFormData.patientMRN,
                patientAcctNo: addCaseManualFormData.patientAcctNo,
                dob: "",
                statementFromDate: format(new Date(addCaseManualFormData.statementFromDateString),"MM/DD/YYYY"),
                statementToDate: format(new Date(addCaseManualFormData.statementToDateString),"MM/DD/YYYY"),
              },
            },
          });
        }, 100);
      } 
    };